<template>
  <!-- This block doesn't need hydration -->
  <LazyHydrate>
    <StandardWrapper v-bind="$attrs" :blok="blok" width="text" no-padding>
      <div
        class="prose prose-lg raw-html"
        :class="[
          listClass,
          textColorClass(blok.textVariant, blok.bgVariant),
          isBackgroundDark(blok.bgVariant) ? 'prose-white' : 'prose-blue',
        ]"
        v-html="blok.html"
      />
    </StandardWrapper>
  </LazyHydrate>
</template>

<script setup>
import { computed } from 'vue'
import StandardWrapper from '../components/StandardWrapper.vue'
import { usePageContext } from '../renderer/usePageContext'
import { useHead } from '@unhead/vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { textColorClass, colorName, isBackgroundDark } = useColorPalette()

const listClass = computed(() => {
  if (props.blok) {
    const listBulletType = props.blok.listBulletType || 'triangle-bullet'
    // checkmark heavy-checkmark circle-bullet triangle-bullet arrowhead chevron-right
    const listBulletColor = `list-${colorName(
      props.blok.listBulletColor,
      props.blok.bgVariant,
    )}`

    return `jb-list ${listBulletColor} ${listBulletType}`
  }
  return ''
})

const pageContext = usePageContext()
useHead(() => {
  const head = {}
  if (props.blok.external_script) {
    if (props.blok.external_script.startsWith('https')) {
      head.script = [
        {
          nonce: pageContext.nonce,
          src: props.blok.external_script,
          async: true,
        },
      ]
    } else {
      head.script = [
        {
          nonce: pageContext.nonce,
          type: 'text/javascript',
          innerHTML: props.blok.external_script,
        },
      ]
    }
  }
  return head
})
</script>

<style>
/* To guarantee that Youtube embeds look of in mobile resolution */
.raw-html iframe {
  max-width: 100%;
}
</style>
